import { memo, useContext, useMemo } from 'react';
import { Position } from '@xyflow/react';
import { getLiteral } from 'utils/getLiteral';

import { findNodeByType, AUTOMATION_ENTITIES } from '../../../utils';
import { AutomationBuilderCanvasContext } from '../AutomationBuilderCanvasContext';
import AutomationBuilderBox from '../components/AutomationBuilderBox';
import AutomationCanvasHandle from '../components/AutomationCanvasHandle';

const AutomationBuilderTriggerBox = memo((props) => {
    const { data } = useContext(AutomationBuilderCanvasContext);
    const nodeData = useMemo(() => findNodeByType(data?.scene, props.id), [data?.scene, props.id]);
    const textValue = useMemo(() => {
        const entity = AUTOMATION_ENTITIES.find(
            (entity) => entity.trueName === nodeData?.parameters?.entity?.value,
        );

        if (!entity || !nodeData?.parameters?.action) return;
        let text = `${getLiteral(entity?.labels?.singular)} ${getLiteral(nodeData?.parameters?.action?.title)}`;
        if (nodeData?.parameters?.withCreation)
            text += ` (${getLiteral('label_automation_event_creation_included')})`;
        return text;
    }, [nodeData]);

    return (
        <>
            <AutomationBuilderBox
                {...props}
                className="fm-automation-builder__trigger-box"
                title={getLiteral('label_trigger')}
                icon={
                    nodeData?.parameters?.entity
                        ? nodeData?.parameters?.entity?.value
                        : 'arrowDropRightRaw'
                }
                secondIcon={nodeData?.parameters?.action?.icon}
                textValue={textValue}
                emptyPlaceholder={getLiteral('action_automation_add_trigger')}
                isIncomplete={nodeData?._isIncomplete}
            ></AutomationBuilderBox>
            <AutomationCanvasHandle
                className="fm-automation-builder__handler-trigger"
                type="source"
                position={Position.Bottom}
                id="bottom"
                boxId={props.id}
                isConnectable={false}
                isIncomplete={nodeData?._isIncomplete}
            />
        </>
    );
});

export default AutomationBuilderTriggerBox;
